import React from 'react';
import { get } from 'lodash';

import FilterWrapper from '../../../components/Common/FilterWrapper';
import InputWrapper from '../../../components/Common/InputWrapper';
import NowSelect from '../../../components/Common/NowSelect';
import { trans } from '../../../localization/index';
import { getPermissionRestaurant, setLocalStore } from '../../../utils/utils';
import { EnumMerchantPermission, EnumLocalStorage } from '../../../constants/enum';

class StaffManagementFilter extends React.Component {
  restaurantOptions = getPermissionRestaurant(
    this.props.restaurants,
    EnumMerchantPermission.STAFF_MANAGEMENT.id,
  ).map(res => ({
    value: res.restaurant_id,
    label: res.is_use_partner_app ? (
      <div className="choose-restaurant-modal-option">
        {res.name}
        <div className="choose-restaurant-modal-option-tag">
          {trans('merchant_transfer_simpleDialog_text_transferred')}
        </div>
      </div>
    ) : res.name,
  }));

  handleChangeRestaurant = (value) => {
    const { filters, restaurants, handleChangeFilters, handleSearch, handleSetCurrentRestaurant } = this.props;
    const { restaurant } = filters;
    if (value === null || value.value !== restaurant.value) {
      handleChangeFilters('restaurant', value);

      const curRestaurant = restaurants.find(item => item.restaurant_id === value.value);
      handleSetCurrentRestaurant(curRestaurant)
      setLocalStore(EnumLocalStorage.CURRENT_RESTAURANT, {
        restaurantId: curRestaurant.restaurant_id,
      });

      const isTransfer = get(curRestaurant, 'is_use_partner_app', false);
      if (!isTransfer) {
        handleSearch();
      }
    }
  };

  render() {
    const { filters } = this.props;
    const { restaurant } = filters;

    return (
      <FilterWrapper>
        <InputWrapper label={trans('set_staff_option_restaurant')} width={300}>
          <NowSelect
            value={restaurant}
            options={this.restaurantOptions}
            onChange={this.handleChangeRestaurant}
            isClearable={false}
          />
        </InputWrapper>
        {/* 本期隐藏 */}
        {/* <InputWrapper>
          <button
            type="button"
            className="btn btn-red mr-2"
            onClick={() => openCreateModal({})}
          >
            {trans('set_staff_create_staff')}
          </button>
        </InputWrapper> */}
      </FilterWrapper>
    );
  }
}

export default StaffManagementFilter;



// WEBPACK FOOTER //
// ./foody/src/pages/Staff/components/StaffManagementFilter.jsx